module.exports = __webpack_public_path__ + "img/item_bookCover_03.3f968ebc.jpeg";